import {Controller} from '@hotwired/stimulus';

/**
 * Demande du lien de connexion par e-mail (page de connexion) : le formulaire part en `fetch` vers son `action`,
 * bouton d'envoi désactivé. Une réponse OK affiche son `message` dans la target `status` (classe `ok`) et laisse
 * le bouton désactivé ; une erreur y affiche ses `errors`, marque le champ `email` (classe `error`) quand il est en
 * cause et réactive le bouton. Le statut s'affiche et se masque par `style.display`.
 *
 *   <form action="{{ path('sessions.login.passwordless_mail_send') }}"
 *         {{ stimulus_controller('sessions--magic-link')|stimulus_action('sessions--magic-link', 'send', 'submit') }}>
 *     <input name="email" {{ stimulus_target('sessions--magic-link', 'email') }}>
 *     <input type="submit" {{ stimulus_target('sessions--magic-link', 'submit') }}>
 *     <div {{ stimulus_target('sessions--magic-link', 'status') }}></div>
 *   </form>
 */
export default class extends Controller {
  static targets = ['email', 'submit', 'status'];

  async send(event) {
    event.preventDefault();

    this.submitTarget.disabled = true;
    this.emailTarget.classList.remove('error');
    this.statusTarget.style.display = 'none';
    this.statusTarget.classList.remove('error');
    this.statusTarget.replaceChildren();

    const response = await fetch(this.element.action, {
      method: 'POST',
      body: new URLSearchParams(new FormData(this.element)),
      headers: {'X-Requested-With': 'XMLHttpRequest'},
    });
    const data = await response.json();

    if (response.ok) {
      this.statusTarget.classList.add('ok');
      this.statusTarget.textContent = data.message;
      this.statusTarget.style.display = 'block';

      return;
    }

    const messages = document.createElement('span');
    (data.errors ?? []).forEach((error) => {
      if (error.property_path === '[email]') {
        this.emailTarget.classList.add('error');
      }

      const message = document.createElement('span');
      message.textContent = error.message;
      messages.append(message);
    });

    this.statusTarget.classList.add('error');
    this.statusTarget.replaceChildren(messages);
    this.statusTarget.style.display = 'block';
    this.submitTarget.disabled = false;
  }
}
